import { useTranslation } from 'react-i18next';

const useLocale = () => {
	const { i18n } = useTranslation();
	return ["ua", "en"].includes(i18n.language) ? i18n.language : "en";
};

export default useLocale;